import React, { useEffect, useState } from "react";
import App from "../Utils/LayoutMobile";
import Dashbordcard from "./Skinola/Dashbordcard";
import SalesOverview from "./Skinola/SalesOverview";
import EventDashboard from "./Skinola/EventDashboard";
import axiosInstance from "../api/axiosInstance";
import { resetApolloContext } from "@apollo/client";
import Upcomeingevent from "./Skinola/upcomeingevent";

function Home() {
  const [dashboardData, setDashboardData] = useState({
    totalCount: 0,
    totalSales: 0,
    todaysRegistrations: 0,
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axiosInstance.get("/api/v1/userRegistration/dashboard");
        setDashboardData(response.data);
        console.log("::dashbord data ::",response)
      } catch (error) {
        console.log("::error dashbord data:::",error)
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);
  console.log(":::user data:::",dashboardData)
  return (
    <App>
      <div>
        <Dashbordcard data={dashboardData} />
        {/* <SalesOverview data={dashboardData} />
        <EventDashboard data={dashboardData} />
        <Upcomeingevent data={dashboardData}/> */}
      </div>
    </App>
  );
}

export default Home;
